function UniqueKey() {
    return new Date().getTime();
  }

  export default UniqueKey;